
export default class MaxStack {
    constructor () {
        this.stack = []
        this.maxStack = []
    }

    push (number) {
        this.stack.push(number)
        if (!this.maxStack.length || number >= this.getMax()) {
            this.maxStack.push(number)
        }
    }

    pop () {
        if (this.stack.length) {
            let item = this.stack.pop()
            if (item === this.getMax()) {
                this.maxStack.pop()
            }
        }
    }

    top () {
        return this.stack[this.stack.length - 1]
    }

    getMax () {
        return this.maxStack[this.maxStack.length - 1]
    }
}
